/** Route rule ids that grant read but no write (Bitwarden, Dropbox audit). */
// eslint-disable-next-line import/prefer-default-export
export const READ_ONLY_ROUTE_RULE_IDS = new Set([
  'admin-tools-bitwarden-secrets',
  'admin-tools-dropbox-audit',
]);
